<template>
  <div class="card">
    <Toolbar class="p-mb-4">
      <template #start>
        <Button
          label="Novo"
          icon="pi pi-plus"
          class="mr-2"
          @click="showCreate()"
        />
      </template>
      <template #end>
        <div
          class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between"
        >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>
    </Toolbar>
    <DataTable
      ref="dt1"
      dataKey="id"
      class="p-datatable-sm"
      :value="allRegitros"
      :paginator="true"
      :rows="10"
      :filters="filters"
      :rowsPerPageOptions="[10, 15, 20, 50]"
      :globalFilterFields="['subUnidade.descricao']"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} registros."
    >
      <template #empty>
        <div class="text-center">Nenhum resultado encontrado...</div>
      </template>
      <Column header="Periodo" field="periodo" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.periodo }}
        </template>
      </Column>
      <Column header="Valor" field="valor" :sortable="true">
        <template #body="slotProps">
          {{
            slotProps.data.valor.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>
      </Column>

      <Column
        header="Nome do Setor"
        field="subUnidade.descricao"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.subUnidade.descricao }}
        </template>
      </Column>

      <Column
        header="Unidade Pertencente"
        field="subUnidade.unidade.descricao"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.subUnidade.unidade.descricao }}
        </template>
      </Column>

      <Column header="Tipo" field="tipo.descricao" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.tipo.descricao }}
        </template>
      </Column>

      <Column header="Ações">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success mr-2"
            @click="showUpdate(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EDITAR'"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="showRemove(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EXCLUIR'"
          />
        </template>
      </Column>
    </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>
  <dialog-form :selected="registro" @findAll="findAll()" />
</template>

<script>
import { FilterMatchMode } from "primevue/api";

//models
import Registro from "../../models/registro";

//Services
import RegistroService from "../../service/registro/registroService";

//components
import DialogForm from "./components/dialog-form.vue";

export default {
  components: {
    DialogForm,
  },
  data() {
    return {
      filters: {},
      allRegitros: [],
      registro: new Registro(),
      registroService: new RegistroService(),
      loading: false,
    };
  },
  created() {
    this.initFilters();
  },
  mounted() {
    this.findAll();
  },
  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    showCreate() {
      this.registro = new Registro();
      this.$store.state.views.registro.dialogForm = true;
    },
    showUpdate(data) {
      this.registro = { ...data };
      this.$store.state.views.registro.dialogForm = true;
    },
    showRemove(data) {
      this.registro = data;
      this.$confirm.require({
        message: "Deseja excluir esse registro?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.registroService
            .delete(this.registro.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findAll();
            })
            .catch((err) => {
              this.loading = false;
              this.$toast.add({
                severity: "error",
                summary: "Alerta de Erro.",
                detail: err,
                life: 6000,
              });
            });
        },
      });
    },
    findAll() {
      this.registroService.findAll().then((data) => {
        this.allRegitros = data;
      });
    },
    teste() {
      console.log(event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
